import { api } from '../../../constants/api';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

export const getConfiguredApiBaseUrl = (): string | null => {
  const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

  return configuredBaseUrl ? trimTrailingSlash(configuredBaseUrl) : null;
};

export const resolveApiBaseUrl = (): string | null => {
  const configuredBaseUrl = getConfiguredApiBaseUrl();
  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  return api[window.location.origin] ?? null;
};
